// Google Tag Manager Configuration
export const GTM_ID = 'GTM-KK77Z98X';

// Función para inicializar el dataLayer si no existe
export const initializeDataLayer = () => {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || [];
  }
};

// Función para enviar eventos personalizados al dataLayer
export const pushToDataLayer = (data) => {
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push(data);
  }
};

// Eventos específicos para GTM
export const trackPageView = (pagePath, pageTitle) => {
  pushToDataLayer({
    event: 'page_view',
    page_path: pagePath,
    page_title: pageTitle,
    page_location: window.location.href
  });
};

// Eventos de engagement
export const trackCTAClick = (ctaName, section, ctaType = 'button') => {
  pushToDataLayer({
    event: 'cta_click',
    cta_name: ctaName,
    cta_section: section,
    cta_type: ctaType,
    page_path: window.location.pathname
  });
};

// Eventos de video
export const trackVideoEvent = (action, videoName, section, progress = null) => {
  const eventData = {
    event: 'video_interaction',
    video_action: action,
    video_name: videoName,
    video_section: section,
    page_path: window.location.pathname
  };
  
  if (progress !== null) {
    eventData.video_progress = progress;
  }
  
  pushToDataLayer(eventData);
};

// Eventos de formulario
export const trackFormEvent = (action, formName, formType = 'contact') => {
  pushToDataLayer({
    event: 'form_interaction',
    form_action: action,
    form_name: formName,
    form_type: formType,
    page_path: window.location.pathname
  });
};

// Eventos de scroll
export const trackScrollEvent = (scrollDepth) => {
  pushToDataLayer({
    event: 'scroll_depth',
    scroll_depth: scrollDepth,
    page_path: window.location.pathname
  });
};

// Eventos de navegación
export const trackNavigation = (destination, navigationType = 'internal') => {
  pushToDataLayer({
    event: 'navigation',
    navigation_destination: destination,
    navigation_type: navigationType,
    page_path: window.location.pathname
  });
};

// Eventos de usuario
export const trackUserAction = (action, category, label, value = null) => {
  const eventData = {
    event: 'user_action',
    action: action,
    category: category,
    label: label,
    page_path: window.location.pathname
  };
  
  if (value !== null) {
    eventData.value = value;
  }
  
  pushToDataLayer(eventData);
};

// Alias para compatibilidad
export const trackAction = trackUserAction;

// Eventos de conversión
export const trackConversion = (conversionType, conversionValue = null, currency = 'USD') => {
  const eventData = {
    event: 'conversion',
    conversion_type: conversionType,
    page_path: window.location.pathname
  };
  
  if (conversionValue !== null) {
    eventData.value = conversionValue;
    eventData.currency = currency;
  }
  
  pushToDataLayer(eventData);
};

// Eventos de error
export const trackError = (errorType, errorMessage, errorLocation) => {
  pushToDataLayer({
    event: 'error',
    error_type: errorType,
    error_message: errorMessage,
    error_location: errorLocation,
    page_path: window.location.pathname
  });
};

// Eventos de tiempo en página
export const trackTimeOnPage = (timeSpent) => {
  pushToDataLayer({
    event: 'time_on_page',
    time_spent: timeSpent,
    page_path: window.location.pathname
  });
};

// Función para configurar variables personalizadas
export const setCustomVariable = (key, value) => {
  pushToDataLayer({
    custom_variable_key: key,
    custom_variable_value: value
  });
};

// Función para configurar información del usuario
export const setUserInfo = (userId, userType = 'visitor') => {
  pushToDataLayer({
    user_id: userId,
    user_type: userType,
    event: 'user_info_set'
  });
};
